/* eslint-disable react/prop-types */
import React, { Component } from "react";
import Navbar from "react-bootstrap/lib/Navbar";
import Nav from "react-bootstrap/lib/Nav";
import NavItem from "react-bootstrap/lib/NavItem";
import NavDropdown from "react-bootstrap/lib/NavDropdown";
import MenuItem from "react-bootstrap/lib/MenuItem";
import { withRouter } from "react-router-dom";
import { Dimmer, Flag, Icon, Image, Loader } from "semantic-ui-react";
import { connect } from "react-redux";
import Strings from "utilities/StringSelector";
import Constants from "utilities/Constants";
import {
  tsExpertAction,
  configAction,
  // ----------------------- Protocol ----------------------------
  protocolResumeAction,
  protocolLivelistAction,
  protocolLiveListMatrixAction,
  protocolLogAction,
  // ----------------------- Physical Medium DP ----------------------------
  dnLiveListAction,
  dnLiveListMatrixAction,
  dnOscilloscopeAction,
  dnBarGraphAction,
  dnLogAction
} from "actions/changeActiveItemActions";
import getLanguageOptions from "utilities/LanguageOptions";

class BootstrapMenuBar extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      dropdownTitle: Strings.MONITORING,
      languageKey: localStorage.getItem(Constants.LOCAL_STORAGE_KEY) || Constants.PT_LANG_KEY,
      language: Strings.PORTUGUESE,
      isUpdatingLanguageDimmerActive: false,
      monitoringStyle: { display: "block" },
      oscilloscopeStyle: { display: "none" }
    };
  }

  setMenuBarCurrentState = () => {
    const currentPath = this.props.history.location.pathname;

    if (currentPath.includes("/dn-")) {
      this.setState({
        dropdownTitle: Strings.PHYS_MEDIUM,
        monitoringStyle: {
          display: "none"
        },
        oscilloscopeStyle: {
          display: "block"
        }
      });
    }
    else {
      this.setState({
        dropdownTitle: Strings.MONITORING,
        monitoringStyle: {
          display: "block"
        },
        oscilloscopeStyle: {
          display: "none"
        }
      });
    }
  }

  handleSelect = (eventKey) => {
    switch (eventKey) {
      // ----------------------- TS Expert ----------------------------
      case "/":
        this.props.onChangeTSExpert();
        this.props.history.push("/");
        break;
      // ----------------------- Protocol ----------------------------
      case "/protocol-resume":
        this.props.onChangeProtocolResume();
        this.props.history.push("/protocol-resume");
        break;
      case "/protocol-livelist":
        this.props.onChangeProtocolLiveList();
        this.props.history.push("/protocol-livelist");
        break;
      case "/protocol-livelist-matrix":
        this.props.onChangeProtocolLiveListMatrix();
        this.props.history.push("/protocol-livelist-matrix");
        break;
      case "/protocol-log":
        this.props.onChangeProtocolLog();
        this.props.history.push("/protocol-log");
        break;
        
      // ----------------------- Physical Medium DN ----------------------------
      case "/dn-live-list":
        this.props.onChangeDpLiveList();
        this.props.history.push("/dn-live-list");
        break;
      case "/dn-live-list-matrix":
        this.props.onChangeDpLiveListMatrix();
        this.props.history.push("/dn-live-list-matrix");
        break;
      case "/dn-oscilloscope":
        this.props.onChangeDpOscilloscope();
        this.props.history.push("/dn-oscilloscope");
        break;
      case "/dn-bar-graph":
        this.props.onChangeDpBarGraph();
        this.props.history.push("/dn-bar-graph");
        break;
      case "/dn-log":
        this.props.onChangeDnLog();
        this.props.history.push("/dn-log");
        break;
      // ----------------------- Config ----------------------------
      case "/config":
        this.props.onChangeConfig();
        this.props.history.push("/login-handler");
        break;
      default:
        break;
    }
  }

  handleDropdownSelect = (eventKey) => {
    if (eventKey === "/drop-mon") {
      this.setState({
        dropdownTitle: Strings.MONITORING,
        monitoringStyle: {
          display: "block"
        },
        oscilloscopeStyle: {
          display: "none"
        }
      }, () => {
        this.handleSelect("/protocol-resume");
      });
    }
    else if (eventKey === "/drop-osc") {
      this.setState({
        dropdownTitle: Strings.PHYS_MEDIUM,
        monitoringStyle: {
          display: "none"
        },
        oscilloscopeStyle: {
          display: "block"
        }
      }, () => {
        this.handleSelect("/dn-live-list");
      });
    }
  }

  handleLanguageChange = language => {
    this.setState({ isUpdatingLanguageDimmerActive: true });
    fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "language_POST", {
      method: "POST",
      headers: { "Content-Type": "application/json;charset=UTF-8" },
      body: JSON.stringify({ language })
    })
      .then(response => {
        if (!response.ok) throw new Error("HTTP " + response.status);
        localStorage.setItem(Constants.LOCAL_STORAGE_KEY, language);
        window.location.reload();
      })
      .catch(error => alert(Strings.UNABLE_TO_ALTER_LANGUAGE + Strings.REASON + error))
      .finally(() => this.setState({ isUpdatingLanguageDimmerActive: false }));
  };

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.setMenuBarCurrentState();
  }

  render() {
    let activePage = { "activeItem": "/" + this.props.location.pathname.split("/")[1] };

    if (activePage.activeItem === "/login" || activePage.activeItem === "/login-handler") {
      activePage.activeItem = "/config";
    }

    const { activeItem } = activePage;
    const languageOptions = getLanguageOptions(Strings);
    const selectedLanguage = languageOptions.find(option => option.key === this.state.languageKey) || languageOptions[0];

    return (
      <>
        <Navbar fluid defaultExpanded inverse collapseOnSelect style={menuStyle}>
          <Navbar.Header>
            <Navbar.Brand>
              <Image
                src={`${process.env.PUBLIC_URL}/logo.png`}
                alt={Strings.TS_MONITOR_LOGO_ALT}
                as="button"
                style={noBorderStyle}
                size="tiny"
                onClick={() => {
                  this.handleSelect("/");
                }}
              />
            </Navbar.Brand>
            <Navbar.Toggle />
          </Navbar.Header>

          <Navbar.Collapse>

            <Nav pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
              <NavItem
                style={fontStyle}
                eventKey="/"
                active={activeItem === "/"}>
                {Strings.TS_EXPERT}
              </NavItem>
            </Nav>

            <Nav pullLeft bsStyle="pills" onSelect={k => this.handleDropdownSelect(k)}>
              <NavDropdown id="nav-drop" style={fontStyle} title={this.state.dropdownTitle}>
                <MenuItem eventKey="/drop-mon">{Strings.MONITORING}</MenuItem>
                <MenuItem eventKey="/drop-osc">{Strings.PHYS_MEDIUM}</MenuItem>
              </NavDropdown>
            </Nav>

            {/* ------------------------------- Protocolo ------------------------------- */}
            <Nav style={this.state.monitoringStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
              <NavItem
                style={fontStyle}
                eventKey="/protocol-resume"
                active={activeItem === "/protocol-resume"}>
                {Strings.RESUME}
              </NavItem>
            </Nav>

            <Nav style={this.state.monitoringStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
              <NavItem
                style={fontStyle}
                eventKey='/protocol-livelist'
                active={activeItem === "/protocol-livelist"}>
                {Strings.LIVE_LIST}
              </NavItem>
            </Nav>

            <Nav style={this.state.monitoringStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
              <NavItem
                style={fontStyle}
                eventKey='/protocol-livelist-matrix'
                active={activeItem === "/protocol-livelist-matrix"}>
                {Strings.MATRIX}
              </NavItem>
            </Nav>

            <Nav style={this.state.monitoringStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
              <NavItem
                style={fontStyle}
                eventKey='/protocol-log'
                active={activeItem === "/protocol-log"}>
                {Strings.LOG}
              </NavItem>
            </Nav>

            {/* ------------------------------- Physical Medium DP ------------------------------- */}
            <Nav style={this.state.oscilloscopeStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
              <NavItem
                style={fontStyle}
                eventKey="/dn-live-list"
                active={activeItem === "/dn-live-list"}>
                {Strings.LIVE_LIST}
              </NavItem>
            </Nav>

            <Nav style={this.state.oscilloscopeStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
              <NavItem
                style={fontStyle}
                eventKey="/dn-live-list-matrix"
                active={activeItem === "/dn-live-list-matrix"}>
                {Strings.MATRIX}
              </NavItem>
            </Nav>

            <Nav style={this.state.oscilloscopeStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
              <NavItem
                style={fontStyle}
                eventKey="/dn-oscilloscope"
                active={activeItem === "/dn-oscilloscope"}>
                {Strings.OSCILLOSCOPE}
              </NavItem>
            </Nav>

            <Nav style={this.state.oscilloscopeStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
              <NavItem
                style={fontStyle}
                eventKey="/dn-bar-graph"
                active={activeItem === "/dn-bar-graph"}>
                {Strings.BAR_GRAPH}
              </NavItem>
            </Nav>

            <Nav style={this.state.oscilloscopeStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
              <NavItem
                style={fontStyle}
                eventKey='/dn-log'
                active={activeItem === "/dn-log"}>
                {Strings.LOG}
              </NavItem>
            </Nav>

            <Nav pullRight bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
              <NavItem
                style={fontStyle}
                eventKey='/config'
                active={activeItem === "/config"}>
                <Icon name="cog" />
                {Strings.CONFIG_STRING}
              </NavItem>
            </Nav>

            <Nav pullRight bsStyle="pills">
              <NavDropdown
                id="language-dropdown"
                title={selectedLanguage.label}
                onSelect={this.handleLanguageChange}>
                {languageOptions.map(option => (
                  <MenuItem key={option.key} eventKey={option.key}>
                    <Flag name={option.flag} />
                    {option.label}
                  </MenuItem>
                ))}
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Navbar >
        <Dimmer page active={this.state.isUpdatingLanguageDimmerActive}>
          <Loader size="big">{Strings.UPDATING_LANGUAGE_WAITING}</Loader>
        </Dimmer>
      </>
    );
  }
}

const mapStateToProps = state => ({
  active: state.activeMenuItem
});

const mapActionsToProps = {
  onChangeTSExpert: tsExpertAction,
  onChangeConfig: configAction,
  // ----------------------- Protocol ----------------------------
  onChangeProtocolResume: protocolResumeAction,
  onChangeProtocolLiveList: protocolLivelistAction,
  onChangeProtocolLiveListMatrix: protocolLiveListMatrixAction,
  onChangeProtocolLog: protocolLogAction,
  // ----------------------- Physical Medium DP ----------------------------
  onChangeDpLiveList: dnLiveListAction,
  onChangeDpLiveListMatrix: dnLiveListMatrixAction,
  onChangeDpOscilloscope: dnOscilloscopeAction,
  onChangeDpBarGraph: dnBarGraphAction,
  onChangeDnLog: dnLogAction,
};

const menuStyle = {
  backgroundColor: "#262626",
  padding: "8pt",
  borderRadius: "0pt",
  borderWidth: 0
};

const fontStyle = {
  fontSize: "medium"
};

const noBorderStyle = {
  border: "none",
  background: "none",
  marginTop: "-4pt",
};

export default connect(mapStateToProps, mapActionsToProps)(withRouter(BootstrapMenuBar));
